// Copyright 2018 Sorama B.V.

import { autoinject, transient } from "aurelia-framework";
import { CreditsMutation } from "datatypes/SoramaWebApi";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { IWorkflowModuleActivate } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { CreditsBalanceRepository } from "repositories/CreditsBalanceRepository";
import { ICreditsService } from "services/Credits/ICreditsService";

@transient()
@autoinject
export class CreditsStatusModule implements IWorkflowModuleActivate {
    private creditsMutationList: CreditsMutation[];

    private errorMessage: string;
    public noInternetString: string;

    constructor(
        private readonly creditsService: ICreditsService,
        private readonly creditsBalanceRepository: CreditsBalanceRepository,
        private readonly authentication: IAuthentication
    ) {}

    public activateModule(): void {
        this.showCreditsMutation();
    }

    private onError(e: Error): void {
        this.errorMessage = e.message;
    }

    private showCreditsMutation(): void {
        this.creditsMutationList = undefined;
        // Let the backend filter out transactions without any amount and take the last 50 transactions
        const filterQuery = "$filter=Amount ne 0&$orderby=TimeStamp desc&$top=50";
        const request = this.creditsBalanceRepository.getCreditsMutationSetForCreditsBalance(
            this.authentication.businessUnitId,
            filterQuery
        );
        request
            .readToEnd()
            .then((mutations: CreditsMutation[]) => {
                this.creditsMutationList = mutations.map((x) => {
                    if (!x.Data && x.Amount > 0) {
                        x.Data = "Purchased credits";
                    }
                    return x;
                });
            })
            .catch((x) => {
                this.noInternetString = "Can't correctly load Overview. Please check your internet connection.";
                console.log("load Credits Overview rejected ", x);
            });
    }
}
